import Vue from 'vue'
import { JSEncrypt } from 'jsencrypt'
const PublicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCLBIQvCu8Fa+bqhEz+dxkwhDm707XUEZHW1qbVunbrqevTAjKwEgpSnnNyy0ha1mlq15UxSi+c/c+YBhZPnkYmgNoO1KzG6wtVAdCwpmG85S9JzzyZ8gD0o0qHSI6XRMwcYaXlV5vNZkfGos6T1OYTYO28fMEuiIl5aln/F1CEgwIDAQAB";
const PrivateKey = "";
/**
 * RSA 加密
 */
export function RSAEncrypt(string) {
    const jse = new JSEncrypt();
    jse.setPublicKey(PublicKey);
    return jse.encrypt(string);
}
/**
 * RSA 解密
 */
export function RSADecrypt(string) {
    const jse = new JSEncrypt();
    jse.setPrivateKey(PrivateKey);
    return jse.decrypt(string);
}
/**
 * 清除登录信息
 */
export function clearLoginInfo() {
    Vue.cookie.delete('X-Admin-Token');
    Vue.cookie.delete("name");
    Vue.cookie.delete("userid");
    Vue.cookie.delete("isAdmin");
    Vue.cookie.delete("avatar");
    Vue.cookie.delete("isOtherUser");
    Vue.cookie.delete("userType");
}
/**
 * 日期转换
 */
export function dateFtt(date,s,mm) {
    var y = date.getFullYear(),
        m = date.getMonth() + 1,
        d = date.getDate(),
        h = date.getHours(),
        min = date.getMinutes();
    m = m < 10 ? '0' + m : m;
    d = d < 10 ? '0' + d : d;
    h = h < 10 ? '0' + h : h;
    min = min < 10 ? '0' + min : min;
    var str = y + '-' + m + '-' + d + (!s?' ' + h + ':' + min : '') + (mm ? ':'+ (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()):'');
    return str;
}
export function downloadFile(url, fileName) {
    const url1 = window.SITE_CONFIG["baseUrl"]+'/checkmall-file/api/file/downloadFile?fileCode='+ window.SITE_CONFIG["baseUrl"] + url;
    if (window.navigator.msSaveOrOpenBlob) {
        // IE version
        // var blob = new Blob([url], { type: 'application/force-download' })
        // window.navigator.msSaveOrOpenBlob(blob, fileName)
        window.open(url1)
      } else {
        var x = new XMLHttpRequest();
        x.open("GET", url1, true);
        x.responseType = 'blob';
        x.onload=function() {
            var url = window.URL.createObjectURL(x.response)
            var a = document.createElement('a');
            a.href = url
            a.download = fileName;
            a.click()
        }
        x.send();
      }
}
export function previewUrl(url){
    return window.SITE_CONFIG["baseUrl"]+'/checkmall-file/api/file/previewFile?fileCode='+ window.SITE_CONFIG["baseUrl"] + url
}